import api from '../../api/_entre'


const state = () => ({
  entres: [],
  entre: [],
  liste_filtrage_entre: [],
});

// getters
const getters = {
  entres: (state) => {
    return state.entres;
  },
  filtrage_entre_date: (state) => {
    return state.liste_filtrage_entre;
  },
  entre: (state) => {
    return state.entre;
  },
};

// actions
const actions = {
  /**
   * Liste des  ENTRES
   */
  getEntres({ commit }) {
    api.entres().then((response) => {
      commit("SET_ENTRES", response);
    });
  },

  async saveEntre({ commit, dispatch }, data) {
    return api.saveEntre(data).then((response) => {
      commit("SET_ENTRE", response);
      dispatch("getEntres");

      return true;
    });
  },

  getEntre({ commit }, id) {
    api.getEntre(id).then((response) => {
      commit("SET_ENTRE", response);
    });
  },

  destokageEntre({ commit }, id) {
    api.destokageEntre(id).then((response) => {
      commit("SET_DESTOCKAGENTRE", response);
    });
  },

  filterDateEntre({ commit }, data) {
    api.dateFilter(data).then((response) => {
      commit("SET_ENTRES", response);
    });
  },
  
  getFiltrage_entre_date({ commit }, data) {
     return new Promise((resolve, reject) => {
      api.getFiltrage_entre_date(data).then(
        (response) => {
          commit("SET_FILTRAGENTRES", response);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
     });
    
  },
};

// mutations
const mutations = {
  SET_ENTRES(state, entres) {
    state.entres = entres;
  },
  SET_FILTRAGENTRES(state, entres) {
    state.liste_filtrage_entre = entres;
  },

  SET_ENTRE(state, entre) {
    state.entre = entre;
  },
  SET_DESTOCKAGENTRE(state, entre) {
    state.entre = entre;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}
